import { hermesConfig } from '../../../../../edge/request/hermes.config';
import { hermesCourierService } from '../../../../../edge/request/services/hermes.courier.service';
import { createHttpParams } from '../../../../../core/utils/request';
import { UnifiedPipelinesV2Response } from '../interfaces/unifiedPipeline';

// Real backend endpoint (h20 config service), composed from hermesConfig like
// every other /h20 API so the base URL has one source of truth and matches the
// dev-proxy rules. Resolves to:
//   GET /h20/api/config/v2.0/unified/pipelines
// The local mock equivalent was /unified/api/v2.0/pipelines — point back there
// (mock on :3001) to test. Destinations live in UnifiedDestinationsAPI.
const UNIFIED_PIPELINES_V2_URL = hermesConfig.getUnifiedPipelinesURL();

export const UnifiedPipelinesAPI = {
  /**
   * Full pipeline list across both engines (newest-first). GET with no body —
   * filter/search/sort/pagination all happen in the UI. `include_deleted` (query
   * param) is opted in only where deleted pipelines are needed (usage summary);
   * the listing and global search omit it so deleted rows stay hidden.
   */
  async getPipelinesV2(params?: { include_deleted?: boolean }): Promise<UnifiedPipelinesV2Response> {
    // hermesCourierService is the h20 transport; it defaults to background
    // ui-options (no loader / no error toast), so none are hand-rolled here.
    const res = await hermesCourierService.get<UnifiedPipelinesV2Response>(
      UNIFIED_PIPELINES_V2_URL,
      {
        networkOptions: {
          params: createHttpParams({ include_deleted: params?.include_deleted ?? false })
        }
      }
    );

    // The backend error envelope ({ error_message, api_code }) can arrive as a
    // resolved body — reject it here so every consumer lands in its error state
    // instead of crashing on a missing `data` array.
    if (!res || !Array.isArray(res.data)) {
      throw new Error(
        (res as unknown as { error_message?: string })?.error_message ||
          'Failed to fetch Pipelines'
      );
    }

    return res;
  }
};
